import {
    AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild,
    ViewChildren
} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {ApiService} from "../../services/api.service";
import {Response} from "../../dominio/Response";
import {Idiomas} from "../../dominio/idiomas/idiomas";
import {LenguageService} from "../../services/lenguage.service";
import {LenguajeComponent} from "../form/lenguaje/lenguaje.component";
import {ActivatedRoute} from "@angular/router";
import {AuthenticationService} from "../../../core/services/authentication.service";
import {IdiomasMenu} from "../../dominio/idiomas/idiomasMenu";

@Component({
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
    @Output('form-lenguaje') formularios = new EventEmitter();
    @Input('type') type;
    data = [];
    id: string;
    list = new Array<IdiomasMenu>();
    cuenta;
    constructor(private toastr: ToastrService, private apiService: ApiService, private lenguageService: LenguageService, private route: ActivatedRoute, private authService: AuthenticationService) {
        this.cuenta = this.authService.getCookies('cuenta');
        //this.idiomas = this.authService.getCookies('idiomas');
        //this.idiomas = this.idiomas.split(",");
        this.route.params.subscribe(params => {
            this.id = params['id'];
        });
    }

    ngOnInit() {
        this.getLenguagesUser();
    }
    getLenguagesUser() {
        this.apiService.get('usuario/' + this.cuenta)
            .subscribe(  (response: Response) => {
                response.data.idiomas.map(
                    (item, index) => {
                        if (index === 0) {
                            const first = new IdiomasMenu(item.cod, item.nombre);
                            first.visible = true;
                            this.list.push(first);
                        } else {
                            this.list.push(new IdiomasMenu(item.cod, item.nombre));
                        }
                    });
            }, error => {
                this.toastr.warning(error.error.data, 'Error');
            });
    }

    showChildren(cod) {
        this.list.forEach(item => {item.cod === cod ? item.visible = true : item.visible = false; } );
    }

    agregarFormulario(form) {
        // actualizo el formulario del array, quitandolo y agregando su nueva version
        this.data = this.data.filter(item => {
            if (item.cod !== form.cod) {
                return item;
            }
        });
        this.data.push(form);
        this.enviarFormularios();

    }

    enviarFormularios() {
        // chequear que esten todos los formularios sin errores.
        if ((this.data.length === this.list.length) && (!this.faltanCargarFormularios())) {
            this.formularios.emit(this.data);
        } else {
            this.formularios.emit([]);
        }
    }

    faltanCargarFormularios() {
        return this.data.some(item => {
           return item.error === true;
        });
    }

    // getData(cod) {
    //     let lenguajeData;
    //     // chequeo que envien data para actualizar, de lo contrario no envio para ser alta
    //     if (this.data === []) {
    //         lenguajeData = undefined;
    //     } else {
    //         this.data.map(item => {
    //             if ( item.cod === cod) {
    //                 lenguajeData = item;
    //             }
    //         });
    //     }
    //     return lenguajeData;
    // }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/tabs.component.ts